import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: [],
  uuid: null,
  cartAddedAt: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { id } = action.payload;
      const existingProduct = state.cart.find((item) => item.id === id);

      if (existingProduct) {
        if (action.payload.quantity) {
          existingProduct.quantity += action.payload.quantity;
        } else existingProduct.quantity += 1;
      } else {
        state.cart.push({
          ...action.payload,
          quantity: action.payload.quantity ? action.payload.quantity : 1,
        });
        if (!state.cartAddedAt) {
          state.cartAddedAt = new Date().toISOString();
        }
      }
    },

    removeFromCart: (state, action) => {
      const id = action.payload;
      state.cart = state.cart.filter((item) => item.id !== id);
      if (state.cart.length === 0) {
        state.cartAddedAt = null;
      }
    },

    increaseQuantity: (state, action) => {
      const id = action.payload;
      const existingProduct = state.cart.find((item) => item.id === id);

      if (existingProduct) {
        existingProduct.quantity += 1;
      }
    },

    decreaseQuantity: (state, action) => {
      const id = action.payload;
      const existingProduct = state.cart.find((item) => item.id === id);

      if (existingProduct) {
        if (existingProduct.quantity === 1) {
          state.cart = state.cart.filter((item) => item.id !== id);
          if (state.cart.length === 0) {
            state.cartAddedAt = null;
          }
        } else {
          existingProduct.quantity -= 1;
        }
      }
    },

    clearCart: (state) => {
      state.cart = [];
      state.cartAddedAt = null;
    },

    setUUID: (state, action) => {
      state.uuid = action.payload;
    },

    // removeExpiredCart: (state) => {
    //   if (state.cartAddedAt) {
    //     const now = new Date().getTime();
    //     const cartAddedAt = new Date(state.cartAddedAt).getTime();
    //     const age = now - cartAddedAt;
    //     const twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000;
    //     if (age > twoDaysInMilliseconds) {
    //       state.cart = [];
    //       state.cartAddedAt = null;
    //     }
    //   }
    // },
  },
});

export const {
  addToCart,
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart,
  setUUID,
  // removeExpiredCart,
} = cartSlice.actions;

export default cartSlice.reducer;
